export default "__VITE_ASSET__Bga84RGo__"